// extracted by mini-css-extract-plugin
export var footer = "_qo-0";
export var inherit = "_qo-1";
export var input = "_qo-2";
export var modalContent = "_qo-3";
export var quillEditor = "_qo-4";
export var subtitle = "_qo-5";